<template>
<div class="SFmain" :class="{minusCol: !props.showFind}">


    <MyMulti :list="properties.startCities" :choosed="props.choosed.startCity" @input="select('startCity', $event)" placeholder="..." class="select city-select">
        <div class="select__title">Город отправления</div>
    </MyMulti>

    <!-- <MySelect
      class="select"
      mode="multiple"
      label="Город отправления"
      :list="properties.startCities"
      :choosed="choosed.startCity"
      @input="val => select('startCity', val)"
    /> -->


    <MyDates :list="props.properties.dates" :choosed="[props.choosed.dateStartFrom, props.choosed.dateStartTo]" @input="select_dates($event)" placeholder="..." class="dates-select">
        <div class="select__title">Отправление</div>
    </MyDates>

    <MyNights :choosed="[props.choosed.nightsMin, props.choosed.nightsMax]" @input="select_nights($event)" placeholder="..." class="nights-select">
        <div class="select__title">Длительность</div>
    </MyNights>

    <MyMulti :list="properties.ships" :choosed="props.choosed.ship" @input="select('ship', $event)" placeholder="..." class="ship-select select">
        <div class="select__title">{{isSea() ? 'Лайнер' : 'Теплоход'}}</div>
    </MyMulti>


    <!-- <MySelect
      class="select"
      mode="multiple"
      label="Теплоход"
      :list="properties.ships"
      :choosed="choosed.ship"
      @input="val => select('ship', val)"
    /> -->


    <div class="but" v-if="props.showFind">
        <button @click="clickFind" class="btn btn--bluefigma find">Найти</button>
    </div>
  
</div>
</template>

<style lang="scss" src="./SFmain.scss"></style>

<script setup>

import {ref, unref, computed, } from 'vue'
import MyDates from '@/comp/MyDates/MyDates.vue'
import MyNights from '@/comp/MyNights/MyNights.vue'
import MyMulti from '@/comp/MyMulti/MyMulti.vue'
//import MySelect from '@/comp/MySelect/MySelect.vue'

const props = defineProps({
  properties: Object, 
  choosed: Object, 
  last: Object,
  ctype: String,
  showFind: Boolean,
})
const emits = defineEmits([ 'input' ])

const isSea = () => 'sea' === props.ctype

const select = (key, val) => {
  emits('input', {[key]:val} )
}
const select_dates = (all) => {
  let [ dateStartFrom,  dateStartTo ] = all
  emits('input', { dateStartFrom, dateStartTo } )
}

const select_nights = (all) => {
  let [ nightsMin,  nightsMax ] = all
  emits('input', { nightsMin,  nightsMax } )
}

const clickFind = () => {
  emits('input', null, true )
}

</script>
